import VerifyMail from "../../component/verifyMail";

const Verify = () => {
  return (
    <>
      <VerifyMail />
    </>
  );
};

export default Verify;
